module.exports = __webpack_public_path__ + "static/media/logo-agnition-brought-large.20d76814.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-agnition-brought-large.png
// module id = 540
// module chunks = 0